import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
	persistReducer,
	persistStore,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authSlice from "./slices/authSlice";
import releasesSlice from "./slices/releasesSlice";
import supremeEssentialsSlice from "./slices/supremeEssentialsSlices";
import {
	downloadTrackReducer,
	downloadVersionsReducer,
} from "./slices/downloadTrackSlice";
import tagsReducer from "./slices/tagsSlice";
import forYouReducer from "./slices/forYouSlice";
import advancedFilteringReducer from "./slices/advancedFilteringSlice";
import crateReducer from "./slices/crateSlice";
import queueReducer from "./slices/queueSlice";
import favoriteReducer from "./slices/favoriteSlice";
import listenerMiddleware from "../middleware/storeListnerMiddleware";

let userId = null;
try {
	const auth = JSON.parse(localStorage.getItem("auth")) || {};
	if (auth && auth?.user?._id) {
		userId = auth?.user?._id;
  } else {
    userId = "anonymous";
  }
} catch {
	userId = "anonymous";
}

const cratePersistConfig = {
	key: `crate_${userId}`,
	storage,
};

const queuePersistConfig = {
	key: `queue_${userId}`,
	storage,
};

const rootReducer = combineReducers({
	auth: authSlice,
	tracks: releasesSlice,
	supremeEssentials: supremeEssentialsSlice,
	downloadEligibility: downloadTrackReducer,
	downloadVersions: downloadVersionsReducer,
	tags: tagsReducer,
	forYou: forYouReducer,
	advancedFiltering: advancedFilteringReducer,
	crate: persistReducer(cratePersistConfig, crateReducer), // persisted crate
	favorite: favoriteReducer,
	queue: persistReducer(queuePersistConfig, queueReducer), // persisted queue
});

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [
					FLUSH,
					REHYDRATE,
					PAUSE,
					PERSIST,
					PURGE,
					REGISTER,
				],
			},
		}).prepend(listenerMiddleware.middleware),
});

export const persistor = persistStore(store);

// const store = configureStore({
// 	reducer: {
// 		auth: authSlice,
// 		tracks: releasesSlice,
// 		supremeEssentials: supremeEssentialsSlice,
// 		downloadEligibility: downloadTrackReducer,
// 		downloadVersions: downloadVersionsReducer,
// 		tags: tagsReducer,
// 		forYou: forYouReducer,
// 		advancedFiltering: advancedFilteringReducer,
// 		crate: crateReducer,
// 		favorite:favoriteReducer,
// 	},
// });

export default store;

// INFO: Exporting auth actions and thunks
export { logout, handleSessionExpiration } from "./slices/authSlice";

export * from "./slices/crateSlice";
export * from "./slices/favoriteSlice";
export * from "./slices/queueSlice";

// Export all thunks for easy access
export * from "./thunks/authThunks";
export * from "./thunks/trackThunks";
